var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_setup.badgeNamesMap[_vm.attribute]),expression:"badgeNamesMap[attribute]"}],staticClass:"entity-badge",class:_setup.badgeClasses},[_vm._v("\n  "+_vm._s(_setup.badgeNamesMap[_vm.attribute])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }